import { STATUS_FIELD } from "modules/swiftboard/components/advance-filter";
import { SOURCE_STATUS, SUBJECT_TYPE_LABEL } from "../../../features/builder.constants";

// Advanced filter of the Source list. Every key must also be in FILTER_FIELDS of the backend's
// reminder_setup/source/controller.js, the whitelist get-all filters on.
export const sourceFilterFields = [
  {
    key: "status",
    label: "Lifecycle",
    type: "enum",
    group: "Details",
    options: Object.entries(SOURCE_STATUS).map(([value, meta]) => ({ value, label: meta.label })),
  },
  {
    key: "subject_type",
    label: "Subject",
    type: "enum",
    group: "Details",
    options: Object.entries(SUBJECT_TYPE_LABEL).map(([value, label]) => ({ value, label })),
  },
  {
    key: "module_key",
    label: "Module",
    type: "select",
    group: "Details",
    optionsKey: "moduleKeys",
    optionLabel: "label",
    optionValue: "value",
  },
  { ...STATUS_FIELD, group: "Details" },
  { key: "created_date", label: "Created", type: "datetime", group: "Dates" },
];
